import React from 'react'
import { graphql, useStaticQuery } from "gatsby"
import { Bar } from 'react-chartjs-2'
import graphql2chartjs from 'graphql2chartjs'

import { colors } from './ChartUtils'

export const query = graphql`

    fragment metadata on BdmensualCsv {
        label: Mes    
        filter: Entidad
        filter2: Regi_n_Geogr_fica
        filter3: Ciudades_Tur_sticas_de_Playa
        filter4: Grandes_Ciudades
    }


  {

    bd: allBdmensualCsv(
        sort: {fields: Entidad}
    ) {
        TiendasYOcio: nodes {
            data: Tiendas_y_Ocio            
            ...metadata
        }    
        SupermercadosYFarmacias: nodes {            
            data: Supermercados_y_Farmacias
                        ...metadata
        }                      
        Parques: nodes {
            data: Parques
            ...metadata
        }    
        Transporte: nodes {            
            data: Transporte
            ...metadata
        }
        EspaciosDeTranajo: nodes {
            data: Espacios_de_Trabajo
            ...metadata
        }    
    }

    filters: allBdmensualCsv(
        sort: {fields: Regi_n_Geogr_fica}
    ) {        
        filter2: distinct(field: Regi_n_Geogr_fica)
        filter3: distinct(field: Ciudades_Tur_sticas_de_Playa)
        filter4: distinct(field: Grandes_Ciudades)
    }
    
  }
`

const ChartMensualXRubro = (props) => {
    // const { value , onChangeValue, removeNacional } = props;
    const data = useStaticQuery(query)    
    const { bd: entries} = data
    const { filters: filters} = data

    props.onFiltersLoaded(filters) // notify loaded filters    

    let colorXdataset = {} // assign colors for each dataset

    let entriesRs = {}
    Object.keys(entries).forEach(dataSetName => {
        entries[dataSetName].forEach(datapoint => {            
            if(!entriesRs.hasOwnProperty(datapoint['filter'])) entriesRs[datapoint['filter']] = [];
            entriesRs[datapoint['filter']].push({...datapoint, filter: dataSetName});            
        });
    });
    let filter = props.filter || {key: Object.keys(entries)[0], label: Object.keys(entries)[0]} ;


    let filteredEntries = {...entriesRs}; // clone original object     
    let i = 0;
    Object.keys(entriesRs).forEach(dataSetName => {
        filteredEntries[dataSetName] = entriesRs[dataSetName].filter(e => e['filter']==filter.key);
        if (i>=colors.length) i = 0; // reset colors index
        colorXdataset[dataSetName] = colors[i];
        i++;
    });

    let chartTypeVar = ['bar', 'line'].includes(props.chartType) ? props.chartType : 'bar';

    // -------------------------
    const g2c = new graphql2chartjs();
    // add graphql data to graphql2chartjs instance while adding different chart types and properties
    g2c.add(filteredEntries, (dataSetName, dataPoint) => {        
        return {
            ...dataPoint,
            chartType: chartTypeVar,
            borderColor: colorXdataset[dataSetName],
            pointBackgroundColor: colorXdataset[dataSetName],
            backgroundColor: colorXdataset[dataSetName],            
            fill: false
        }
    });
    

    // replace modified dataset names with originals (avoid undercase on State's names)
    let originalLabels = Object.keys(filteredEntries)
    g2c.data.datasets.forEach((ds, idx) => {ds.label = originalLabels[idx]});
    // ----------    

    // apply datasets filter
    if (props.filterDatasets) {
        g2c.data.datasets.forEach((ds, idx) => {ds['hidden'] = !(props.filterDatasets.value==null || (props.filterDatasets.filterName in ds && ds[props.filterDatasets.filterName] == props.filterDatasets.value) ) });
    }


    return(
        <div className="rpt-chart">            
            <h4>{props.filter.label}</h4>
            <Bar data={g2c.data} options={{ legend: {position: 'bottom'} 

                ,tooltips: {
                    callbacks: {
                        label: function(tooltipItem, data) {
                            var label = data.datasets[tooltipItem.datasetIndex].label || '';
                            if (label) {label += ': ';}
                            label += tooltipItem.yLabel.toFixed(2)
                            return label;
                        }
                    }
                }

            }}/>
        </div>
    )

}

export default  ChartMensualXRubro 